import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { Row, Col } from "react-bootstrap";

const COLORS = ["#077834", "#ff4d4f", "#1890ff", "#f1c40f"];

export default function GroupDashboardCharts({ data }) {
  if (!data) return null;

  const districts = data.districts || [];

  const districtPercentage = districts.map((d) => ({
    name: d.name,
    value: d.groups,
  }));


  const familyRepresentation = [
    { name: "Rescued", value: data?.rescued_families || 0 },
    { name: "To Be Rescued", value: data?.to_be_rescued_families || 0 },
    { name: "Community", value: data?.community_families || 0 },
  ];

  return (
    <>
      {/* ================= DISTRICT GRAPHS ================= */}
      <Row className="mt-4">
        <Col xl={6}>
          <div className="mc-card p-3">
            <h5>District / City wise ACT Groups</h5>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={districts}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="groups" fill="#077834" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Col>

        <Col xl={6}>
          <div className="mc-card p-3">
            <h5>District / City wise Rescued Families</h5>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={districts}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="rescued_families" fill="#ff4d4f" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>

      {/* ================= PIE CHARTS ================= */}
      <Row className="mt-4">
        <Col xl={6}>
          <div className="mc-card p-3">
            <h5>District / City Percentage Share</h5>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={districtPercentage} dataKey="value" label>
                  {districtPercentage.map((_, i) => (
                    <Cell key={i} fill={COLORS[i % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </Col>

        <Col xl={6}>
          <div className="mc-card p-3">
            <h5>Family Representation</h5>
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie data={familyRepresentation} dataKey="value" label>
                  {familyRepresentation.map((_, i) => (
                    <Cell key={i} fill={COLORS[i]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>

      {/* ================= 🚨 RED SECTION ================= */}
      <Row className="mt-4">
        <Col xl={12}>
          <div className="mc-card p-4" style={{ border: "2px solid red" }}>
            <h4 style={{ color: "red" }}>
              🚨 Family Representation (Critical Indicators)
            </h4>
            <Row style={{ color: "red", fontWeight: "bold" }}>
              <Col md={4}>
                <p>Total Family Representation</p>
                <p>Rescued Family Representation</p>
                <p>% of Total Rescued Families Joined Group</p>
              </Col>
              <Col md={4}>
                <p>Community Family Representation</p>
                <p>% of Community Families Joined Group</p>
              </Col>
              <Col md={4}>
                <p>To-Be-Rescued Family Representation</p>
                <p>% of To-Be-Rescued Families Joined Group</p>
                <p>Rescued Families at Location Joined</p>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  );
}
